import React from 'react';
export function TextureGuideSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-blue-light to-white" data-id="element-1281">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-1282">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-1283">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1284">
            Guía Visual de Texturas Seguras
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1285">
            Aprende a adaptar cada receta según la etapa de tu bebé con nuestra
            guía visual paso a paso
          </p>
        </div>

        {/* First Image - 4 textures with labels */}
        <div className="mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-1286">
          <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-1287">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pYvG7ZzX5NEQYKNosLUE9N/4-texturas_seguras_para_bebes.png" alt="Guía de texturas seguras para bebés - Puré, tiras, cubos y texturas por edad" className="w-full h-auto" data-id="element-1288" />
          </div>
        </div>

        {/* Second Image - Clean 4 textures grid */}
        <div className="mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-1289">
          <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-1290">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9wJi3MHGAToueriaqENNAt/4.1Baby_Food_Textures_Collage.png" alt="Collage de texturas para bebés - Diferentes etapas de alimentación" className="w-full h-auto" data-id="element-1291" />
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 stagger-children" data-id="element-1292">
          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft" data-id="element-1293">
            <div className="w-12 h-12 bg-baby-gradient-blue rounded-full flex items-center justify-center mb-4 shadow-baby-soft" data-id="element-1294">
              <span className="text-2xl" data-id="element-1295">🥣</span>
            </div>
            <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-3" data-id="element-1296">
              Purés Suaves
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-1297">
              Para bebés de 6+ meses. Textura completamente lisa y homogénea,
              perfecta para comenzar.
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-pink-light shadow-baby-soft" data-id="element-1298">
            <div className="w-12 h-12 bg-baby-gradient-pink rounded-full flex items-center justify-center mb-4 shadow-baby-pink" data-id="element-1299">
              <span className="text-2xl" data-id="element-1300">🥄</span>
            </div>
            <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-3" data-id="element-1301">
              Texturas Gruesas
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-1302">
              Para bebés de 8+ meses. Con pequeños trozos suaves que se deshacen
              fácilmente.
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft" data-id="element-1303">
            <div className="w-12 h-12 bg-baby-gradient-blue rounded-full flex items-center justify-center mb-4 shadow-baby-soft" data-id="element-1304">
              <span className="text-2xl" data-id="element-1305">✋</span>
            </div>
            <h3 className="font-bold text-lg sm:text-xl text-gray-900 mb-3" data-id="element-1306">
              Finger Foods
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-1307">
              Para bebés de 10+ meses. Trozos que pueden agarrar y comer solos
              de forma segura.
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 text-center animate-fade-in-up" style={{
        animationDelay: '0.6s'
      }} data-id="element-1308">
          <div className="inline-block bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 sm:p-8 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-1309">
            <p className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-1310">
              Cada receta incluye adaptaciones para todas las etapas
            </p>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-1311">
              Nunca más tendrás dudas sobre qué textura es segura para tu bebé
            </p>
          </div>
        </div>
      </div>
    </section>;
}